/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DelegateGoogleClassroomAccessRequestContent
 */
export interface DelegateGoogleClassroomAccessRequestContent {
    /**
     * The authorization code returned by Google OAuth. This value
must be URL-decoded (unescaped) before calling this operation,
which is relevant since this code will come from Google in the
form of a query parameter in a redirect.
     * @type {string}
     * @memberof DelegateGoogleClassroomAccessRequestContent
     */
    code: string;
    /**
     * The code verifier which corresponds to the code challenge
that was passed in the initial redirect to Google.
     * @type {string}
     * @memberof DelegateGoogleClassroomAccessRequestContent
     */
    code_verifier: string;
    /**
     * The redirect URI which was passed in the initial redirect to
Google.
     * @type {string}
     * @memberof DelegateGoogleClassroomAccessRequestContent
     */
    redirect_uri: string;
}


/**
 * Check if a given object implements the DelegateGoogleClassroomAccessRequestContent interface.
 */
export function instanceOfDelegateGoogleClassroomAccessRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "code_verifier" in value;
    isInstance = isInstance && "redirect_uri" in value;
    return isInstance;
}

export function DelegateGoogleClassroomAccessRequestContentFromJSON(json: any): DelegateGoogleClassroomAccessRequestContent {
    return DelegateGoogleClassroomAccessRequestContentFromJSONTyped(json, false);
}

export function DelegateGoogleClassroomAccessRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegateGoogleClassroomAccessRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'code': json['code'],
        'code_verifier': json['code_verifier'],
        'redirect_uri': json['redirect_uri'],
    };
}

export function DelegateGoogleClassroomAccessRequestContentToJSON(value?: DelegateGoogleClassroomAccessRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'code': value.code,
        'code_verifier': value.code_verifier,
        'redirect_uri': value.redirect_uri,
    };
}

